import { useMutation } from 'react-query';
import { EditorSubmitContentData } from '@/components/RichTextEditor/types';

import { request, useCurrentUserId, toastError, L2TxReqParams } from '@/utils';

import { FeedArticleDetail } from '../types';
import { setQueryFeedDetailInList } from './list';
import { invalidArticleDetail } from './detail';
import { invalidArticleComments } from './comment';

export const usePayQaAnswer = (articleId?: number, price?: number) => {
  const currentAddress = useCurrentUserId();

  return useMutation(
    ({ thread_data }: { thread_data: EditorSubmitContentData['thread_data'][] }) =>
      request.post<{ is_success: boolean }>('/article/pay_qa/answer', {
        article_id: articleId,
        thread_data,
      }),
    {
      onSuccess: (res, { thread_data }) => {
        if (!res.is_success) {
          toastError('Failed');

          return;
        }

        const handle = (pre?: FeedArticleDetail) => {
          if (pre?.article) {
            pre.article.thread_count = thread_data.length;
            if ('create_at' in pre) {
              pre.create_at = +new Date() / 1000;
            }
          }
        };

        invalidArticleDetail(articleId!, currentAddress);
        setQueryFeedDetailInList(currentAddress!, articleId!, handle);
      },
      onError(err: any) {
        toastError(err || 'failed to answer');
      },
    },
  );
};

export const usePayQaWatch = (id: number) => {
  const currentAddress = useCurrentUserId();

  return useMutation(
    (tx: L2TxReqParams) =>
      request.post<{ is_success: boolean }>('/article/pay_qa/pay', {
        id,
        tx,
      }),
    {
      onSuccess: (res, tx) => {
        const handle = (pre?: FeedArticleDetail) => {
          if (pre?.article?.pay_qa) {
            pre.article.is_paid = true;
            pre.article.pay_qa.is_paid = true;
            pre.article.pay_qa.price = tx.action.amount;
            pre.article.pay_qa.pay_count = (pre.article.pay_qa.pay_count || 0) + 1;
          }
        };

        setQueryFeedDetailInList(currentAddress!, id, handle);
        // 详情页需要再获取一遍 detail，才能拿到 thread 内容
        invalidArticleDetail(id, currentAddress);
        invalidArticleComments(currentAddress);
      },
    },
  );
};
